import { useAtomValue } from "jotai";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@sorcery/ui";

import { maybeboardJotai } from "~/state/deckJotai";
import type { CardType, VariantType } from "~/types/card";
import { DecklistSection } from "./DecklistSection";

type Props = {
  onCardHover?: (squiggle: { card: CardType; variant: VariantType }) => void;
};

export const Maybeboard = ({ onCardHover }: Props) => {
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  const maybeboard = useAtomValue(maybeboardJotai)!;

  if (!maybeboard.length) {
    return null;
  }

  return (
    <Accordion type="single" collapsible={true} className="animate-in fade-in">
      <AccordionItem
        value={"Maybeboard"}
        className="border-t border-t-line-color animate-in fade-in"
      >
        <AccordionTrigger className="pr-1 font-normal">
          <span>
            {"Maybeboard"} (
            {maybeboard.reduce((a: number, c: { quantity: number }) => a + c.quantity, 0)})
          </span>
        </AccordionTrigger>
        <AccordionContent>
          <DecklistSection key={"Maybeboard"} cards={maybeboard} onCardHover={onCardHover} />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
